import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private embeddedSubject = new BehaviorSubject<boolean>(false);
  embedded$ = this.embeddedSubject.asObservable();

  setEmbedded(value: boolean) {
    this.embeddedSubject.next(value);
  }
}
